import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { BusinessTransactionWorkQueueDetailModel } from '../../../shared/models/business-transaction/business-transaction-work-queue-detail-model';
import { BusinessTransactionService } from '../../../shared/services/business-transaction/business-transaction.service';
import { SystemNotificationService } from '../../../shared/services/realtime-messaging/system-notification.service';

export class OverrideRequestData {
    constructor(public requestData: BusinessTransactionWorkQueueDetailModel, public queueData) {}
}

@Component({
    selector: 'override-request-modal',
    templateUrl: './override-request-modal.html'
})

export class OverrideRequestWindow extends BaseComponent {
    public requestData: BusinessTransactionWorkQueueDetailModel;
    public overrideHistory: any[];

    constructor(
        public dialogRef: MatDialogRef<OverrideRequestWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OverrideRequestData,
        public businessTransactionService: BusinessTransactionService,
        private systemNotificationService: SystemNotificationService
    ) {
        super();
    }

    ngOnInit() {
        this.requestData = this.data.requestData;
        this.loadData();

        // Notify the originating CSR
        if (this.data.queueData.escalationWorkQueueId) {
            this.systemNotificationService.dispatchSystemNotification(
                [1],
                [+this.data.requestData.overrideRequestedById],
                `${this.user.name} just picked up the transaction you sent for ${this.data.requestData.escalationType}, and is looking into it.`, null,
                moment().startOf('day').add(1, 'days')
            ).subscribe((x) => { });
        } else {
            this.systemNotificationService.dispatchSystemNotification(
                [1],
                [+this.data.requestData.overrideRequestedById],
                `${this.user.name} just picked up your transaction, and will provide a response to you shortly.`, null,
                moment().startOf('day').add(1, 'days')
            ).subscribe((x) => { });
        }
    }

    loadData() {
        if (this.requestData && this.requestData.transactionId) {
            this.businessTransactionService.getOverrideHistoryForTransaction(this.requestData.transactionId).subscribe((overrideHistoryData) => {
                this.overrideHistory = overrideHistoryData;
            });
        }
    }

    public cancel() {
        this.dialogRef.close();
    }
}
